import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n } from "react/jsx-runtime";
//#region src/components/icons/XCloseIcon.tsx
var r = (e) => /* @__PURE__ */ n(t, {
	viewBox: "0 0 24 24",
	fill: "none",
	...e,
	children: /* @__PURE__ */ n("path", {
		d: "M17.293 5.29302C17.6835 4.90249 18.3165 4.90249 18.707 5.29302C19.0975 5.68354 19.0975 6.31655 18.707 6.70708L13.414 12L18.707 17.293C19.0975 17.6835 19.0975 18.3166 18.707 18.7071C18.3165 19.0976 17.6835 19.0976 17.293 18.7071L12 13.4141L6.70702 18.7071C6.31649 19.0976 5.68348 19.0976 5.29295 18.7071C4.90243 18.3166 4.90243 17.6835 5.29295 17.293L10.5859 12L5.29295 6.70708C4.90243 6.31655 4.90243 5.68354 5.29295 5.29302C5.68348 4.90249 6.31649 4.90249 6.70702 5.29302L12 10.586L17.293 5.29302Z",
		fill: "currentColor"
	})
}), i = {
	12: {
		Artwork: r,
		width: 12,
		height: 12
	},
	16: {
		Artwork: (e) => /* @__PURE__ */ n(t, {
			viewBox: "0 0 16 16",
			fill: "none",
			...e,
			children: /* @__PURE__ */ n("path", {
				d: "M11.4698 3.46979C11.7627 3.1769 12.2374 3.1769 12.5303 3.46979C12.8231 3.76269 12.8232 4.23746 12.5303 4.53034L9.06058 8.00007L12.5303 11.4698C12.8231 11.7627 12.8232 12.2375 12.5303 12.5303C12.2374 12.8232 11.7627 12.8232 11.4698 12.5303L8.00003 9.06061L4.53031 12.5303C4.23743 12.8232 3.76266 12.8232 3.46976 12.5303C3.17687 12.2374 3.17687 11.7627 3.46976 11.4698L6.93949 8.00007L3.46976 4.53034C3.17687 4.23745 3.17687 3.76269 3.46976 3.46979C3.76265 3.1769 4.23742 3.1769 4.53031 3.46979L8.00003 6.93952L11.4698 3.46979Z",
				fill: "currentColor"
			})
		}),
		width: 16,
		height: 16
	},
	20: {
		Artwork: r,
		width: 20,
		height: 20
	},
	24: {
		Artwork: r,
		width: 24,
		height: 24
	}
}, a = ({ size: t = 16, tone: r = "default", className: a, ...o }) => /* @__PURE__ */ n(e, {
	source: i[t],
	monochrome: !0,
	className: ["pf-icon-" + r, a].filter(Boolean).join(" "),
	...o
});
//#endregion
export { a as XCloseIcon };
